import React from "react";

const Notifications = () => {
  return (
    <div
      data-uk-dropdown="pos: bottom-justify; boundary: .nba; boundary-align: true"
      id="notif-dropdown"
      className="uk-border-rounded uk-width-5-6"
    >
      <ul className="uk-nav uk-dropdown-nav uk-position-relative uk-width-5-6">
        <li className="uk-nav-header">Notfications</li>
        <li>You have 5 new fans</li>
        <li className="uk-width-5-6">
          Brownskin added your track to playlist added your track to playlist
        </li>
        <li className="uk-nav-divider"></li>
        <li>
          <a href="#!">View all notifications</a>
        </li>
      </ul>
    </div>
  );
};

export default Notifications;
